import { Box, Skeleton } from '@mui/material';
import { makeStyles } from '@mui/styles';

import React from 'react';

const headerSkeletonKeys = ['header-1', 'header-2', 'header-3', 'header-4', 'header-5'];
const rowSkeletonKeys = ['row-1', 'row-2', 'row-3', 'row-4', 'row-5', 'row-6', 'row-7', 'row-8'];
const cellSkeletonKeys = ['cell-1', 'cell-2', 'cell-3', 'cell-4', 'cell-5'];

const useStyles = makeStyles((theme) => ({
  container: {
    padding: `${theme.spacing(2)}`,
  },
  containerItems: {
    display: 'flex',
    gap: '10px',
    marginBottom: '10px',
  },
}));

const SkeletonCharges = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box className={classes.containerItems}>
        <Skeleton variant="text" height={60} width={100} />
        <Skeleton variant="text" height={60} width={100} />
        <Skeleton variant="text" height={60} width={300} />
        <Skeleton variant="text" height={60} width={300} />
        <Skeleton variant="text" height={60} width={50} />
        {headerSkeletonKeys.map((key) => (
          <Skeleton key={key} variant="text" height={60} style={{ flex: 1 }} />
        ))}
      </Box>
      {rowSkeletonKeys.map((rowKey) => (
        <Box key={rowKey} className={classes.containerItems}>
          <Skeleton variant="rectangular" height={60} width={100} />
          <Skeleton variant="rectangular" height={60} width={100} />
          <Skeleton variant="rectangular" height={60} width={300} />
          <Skeleton variant="rectangular" height={60} width={300} />
          <Skeleton variant="rectangular" height={60} width={50} />
          {cellSkeletonKeys.map((cellKey) => (
            <Skeleton key={`${rowKey}-${cellKey}`} variant="rectangular" height={60} style={{ flex: 1 }} />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default SkeletonCharges;
